import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import { SALARY_VERIFICATION, IDENTITY_VERIFICATION } from '@/forms/constants/services';

export default {
    salaryVerification(payload, progressCallback) {
        return Repository.post('/document/upload/v1.0', {
            ...payload,
        }, {
            params: getParams(SALARY_VERIFICATION),
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                progressCallback(percentCompleted);
            },
        });
    },
    identityVerification(payload, progressCallback) {
        return Repository.post('/idscan-application/onboarding/idscan/v3.0', {
            ...payload,
        }, {
            params: getParams(IDENTITY_VERIFICATION),
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                progressCallback(percentCompleted);
            },
        });
    },
};